import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const elevationShadows = {
  1: `0px 2px 1px -1px #00000033,
      0px 1px 1px 0px #00000024,
      0px 1px 2px 0px #0000001A`,
  2: `0px 2px 6px 1px #00000026,
      0px 1px 2px 0px #0000004D`,
  3: `0px 3px 5px -1px #00000033,
      0px 6px 10px 0px #00000026,
      0px 1px 18px 0px #0000001A`,
  4: `0px 2px 3px 0px #0000004D,
      0px 6px 10px 4px #00000026`,
};

const StyledPaper = styled(Box)(({ elevation }) => ({
  backgroundColor: '#fff',
  borderRadius: 8,
  padding: 16,
  transition: 'box-shadow 0.2s ease-in-out',
  boxShadow: elevationShadows[elevation] || elevationShadows[1],
}));

const PaperElevation = ({ elevation = 1, children, ...props }) => {
  return (
    <StyledPaper elevation={elevation} {...props}>
      {children}
    </StyledPaper>
  );
};

export default PaperElevation;
